import PropTypes from 'prop-types';
import React from 'react';
import FormErrorMessage from './formErrorMessage';

const ScrollingFormErrorMessage = ({ text }) => {
  const scrollIntoView = (el) => {
    if (el && el.offsetTop < window.scrollY) {
      el.scrollIntoView();
    }
  };

  return (
    <div ref={scrollIntoView}>
      <FormErrorMessage
        text={text}
      />
    </div>
  );
};
ScrollingFormErrorMessage.propTypes = {
  text: PropTypes.string,
};
ScrollingFormErrorMessage.defaultProps = {
  text: '',
};

export default ScrollingFormErrorMessage;
